import { client, errorValidation } from "./service.js";

export const createMerchant = async function (body) {
    try {
        let response = await client.post(`/merchant/create`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        console.log('here error', error.response.data)
        if (error.response.data && error.response.data.message) {
            return { error: error.response.data.message }
        }
        return errorValidation(error)
    }
}

export const updateMerchant = async function (body) {
    try {
        let response = await client.post(`/merchant/update/${body._id}`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        console.log('here error', error.response.data)
        if (error.response.data && error.response.data.message) {
            return { error: error.response.data.message }
        }
        return errorValidation(error)
    }
}

export const setMerchantRainRefund = async function (merchantId, status, rainRefundTime) {
    try {
        let response = await client.post('/merchant-rain-refund', {
            data: {
                merchantId,
                status,
                rainRefundTime
            }
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const merchantFees = async function (merchantId, type, placeId) {
    try {
        let response = await client.get(`/merchant/${merchantId || '-'}/fees?type=${type}&placeId=${placeId || ''}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const merchantFeesHistory = async function (merchantId, type, placeId, page, limit) {
    try {
        let response = await client.get(`/merchant/${merchantId || '-'}/fees-history?placeId=${placeId || ''}&page=${page || 0}&limit=${limit || 20}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const createMerchantFees = async function (merchantId, body) {
    try {
        let response = await client.post(`/merchant/${merchantId || '-'}/create-fee`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const updateMerchantFees = async function (merchantId, body) {
    try {
        let response = await client.post(`/merchant/${merchantId || '-'}/update-fee`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        console.log('here error', error.response.data)
        if (error.response.data && error.response.data.message) {
            return { error: error.response.data.message }
        }
        return errorValidation(error)
    }
}

export const deleteMerchantFees = async function (merchantId, body) {
    try {
        let response = await client.post(`/merchant/${merchantId}/delete-fee`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        console.log('here error', error.response.data)
        if (error.response.data && error.response.data.message) {
            return { error: error.response.data.message }
        }
        return errorValidation(error)
    }
}

export const createMerchantDeposit = async function (body) {
    // merchant/deposit/request -> POST
    try {
        let response = await client.post(`/merchant/deposit/request`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const updateMerchantDeposit = async function (body) {
    // merchant/deposit/update -> PUT
    try {
        let response = await client.put(`/merchant/deposit/update`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        console.log('here error', error.response.data)
        if (error.response.data && error.response.data.message) {
            return { error: error.response.data.message }
        }
        return errorValidation(error)
    }
}

export const getMerchantDepositList = async function ({ merchantId, isClosed, page, limit }) {
    // merchant/deposit/:merchantId -> GET
    try {
        let response = await client.get(`/merchant/deposit?merchantId=${merchantId}&isClosed=${(isClosed == true || isClosed == false) ? isClosed : ''
            }`, {
            params: {
                page: page,
                limit: limit,
            }
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const getAllowedMerchantSettings = async function (merchantId, body) {
    // merchant-settings
    try {
        let response = await client.get(`/merchant-settings/${merchantId}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}

export const updateMerchantSettings = async function (merchantId, body) {
    // merchant-settings
    try {
        let response = await client.post(`/merchant-settings/${merchantId}`, {
            ...body
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (error) {
        return errorValidation(error)
    }
}